<template>
  <div style="position: relative; margin-bottom: 100px">
    <div class="product-template-section">
      <div class="container" :class="narrowerscreen ? 'narrowerscreen' : ''">
        <div
          class="product-left"
          :style="gallery_show_config == 'default' ? 'width:50%' : 'width:66%'"
        >
          <div v-if="product_res.gallery && product_res.gallery.length">
            <v-product-swiper
              :gallery="product_res.gallery"
              v-if="gallery_show_config == 'default' || !pc_style"
              pagination_style="inline"
              :pic_zoom="pc_style && pic_zoom"
              theme="vogue"
              :swiper_index="swiper_index"
              button_position="bottom"
              :slidesPerView="5"
              is_product="is_product"
              :product_res="product_res"
              :productInfo="product_info"
            >
            </v-product-swiper>
            <v-media-flat
              :gallery="product_res.gallery"
              v-else-if="gallery_show_config == 'flat' && pc_style"
              theme="athena"
              :pic_zoom="pic_zoom"
              :row_count="2"
              is_product="is_product"
              :product_res="product_res"
              :productInfo="product_info"
            ></v-media-flat>
          </div>
          <div v-else style="position: relative;">
            <v-product-tag
              v-if=" $store.state.product_tag_list[product_res.ID]"
              :productTag="$store.state.product_tag_list[product_res.ID]"
              :productInfo="product_info"
            ></v-product-tag>
            <img :src="defaultImage" alt />
          </div>
        </div>
        <div
          class="product-right"
          :style="gallery_show_config == 'default' ? 'width:50%' : 'width:34%'"
        >
          <v-product-add
            ref="productadd"
            theme="athena"
            :product="product_res"
            :computed_price="computed_price"
            :count_down="count_down"
            :count_down_show="count_down_show"
            :cart_type="cart_type"
            :stock="now_variant.buy_able && stock"
            :show_currency_selector="show_currency_selector"
            :paypal_product_position="paypal_product_position"
            :variants_show_config="variants_show_config"
            :bulk_coupon="bulk_coupon"
            :has_bulk_coupon="has_bulk_coupon"
            :variant_attrs="variant"
            :add_cart_data="add_cart_data"
            :add_cart_list="add_cart_list"
            :now_variant="now_variant"
            :enable_facebook="enable_facebook"
            :enable_twitter="enable_twitter"
            :enabel_pinterest="enabel_pinterest"
            :code_display="code_display"
            :code_display_show="code_display_show"
            :currency_style="currency_style"
            :paypal_enabled="paypal_enabled"
            :buyxgety_coupon="buyxgety_coupon"
            :buyxgety-setting="buyxgetySetting"
            :incentives_data="incentives_data"
            :custom_button="custom_button"
            :palette_attrs="palette_attrs"
            :palette_config="palette_config"
            :visitors="visitors"
            :hide_add_btn="hide_add_btn"
            :show_comment_score="show_comment_score"
            :comment="comment"
            :show_product_price="show_product_price"
            :hide_number_select="hide_number_select"
            :show_style="show_style"
            :combinations="style_combination_enable && combinations"
            :style_combination="style_combination"
            :has_special_attrs="has_special_attrs"
            :combination_active="combination_active"
            :group_product="group_product"
            :group_product_price_rules="group_product_price_rules"
            :group_products_title="group_products_title"
            :enable_size_chart="enable_size_chart"
            :untreated_product="product"
          ></v-product-add>
          <div class="payment_img" v-if="payment_img">
            <img :src="payment_img" alt />
          </div>
          <!-- 不启用tabs详情 -->
          <div v-if="!isTabs" class="product-description default_css page_text_font">
            <div
              class="tinymce-content"
              v-html="this.re_remover_class(product_res.post_content)"
              style="overflow-x: auto"
            ></div>
          </div>
          <!-- 启用tabs,平铺模式-->
          <div
            class="productDescriptionWrap accordion"
            id="vogue-pro-accordion"
            v-if="gallery_show_config == 'flat' && isTabs"
          >
            <div
              v-for="(item, index) in describe_tabs"
              :key="item.title + index"
            >
              <v-collapse-card
                parent="#vogue-pro-accordion"
                :title="item.title"
                :default_show="item.type == 'describe' && !item.show"
                :collapse_key="'productContainer' + item.type + index"
              >
                <div style="overflow: hidden; position: relative">
                  <div
                    class="product-description tinymce-content default_css page_text_font"
                    v-html="re_remover_class(item.content)"
                  ></div>
                </div>
              </v-collapse-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 启用tabs,媒体库模式-->
    <div
      class="container module-space"
      v-if="describe_tabs.length && gallery_show_config == 'default' && isTabs"
    >
      <v-descrip-tabs :data="describe_tabs"></v-descrip-tabs>
    </div>
    <!-- 组合商品 -->
    <div class="container module-space">
      <v-newGrpupedProduct
          v-if="group_product && group_product.length && (groupProduct.position === 'right' || groupProduct.position === 'below')"
          :group_product="group_product"
          :group_products_title="group_products_title"
          :show_outer="true"
          :pc_style="pc_style"
          :cart_type="cart_type"
          :theme="theme"
      ></v-newGrpupedProduct>
    </div>
    <v-comments
      v-if="comment && !pc_style"
      :comment="comment"
      :review_count="product.review_count"
      :average_rating="product.average_rating"
      :rating_count="product.rating_count"
      :comments="product.comments"
      :product_id="product.ID"
      :product_review="true"
    ></v-comments>
    <v-guess-like
      v-if="recommended_product && show_recommended"
      :recommended_product="recommended_product"
      :cart_type="cart_type"
      :product_id="product.ID"
      :show_currency_selector="show_currency_selector"
      :currency_style="currency_style"
      :palette_config="palette_config"
      :card_type="card_type"
      :theme="theme"
      :combination_config="combination_config"
    ></v-guess-like>
    <v-comments
      v-if="comment && pc_style"
      :comment="comment"
      :review_count="product.review_count"
      :average_rating="product.average_rating"
      :rating_count="product.rating_count"
      :comments="product.comments"
      :product_id="product.ID"
      :product_review="true"
    ></v-comments>
    <v-new-quick-add-cart
      :quick-add-cart="quickAddCart"
      v-if="quick_add_cart"
      :show-quick-add-cart="quick_add_cart"
      :variant-new="now_variant"
      :product="product"
      :stock="now_variant.buy_able && stock"
      :price="now_variant.price"
      :regular-price="now_variant.regular_price"
      :loading="$store.state.disabled"
      :variant-attrs="product_res.variant_attrs"
      :current-variant="variant"
      :addproduct="add_cart_data"
      @fatherMethod="add_cart"
      :show-currency_selector="show_currency_selector"
      :currency-style="currency_style"
    ></v-new-quick-add-cart>
    <!-- 组合商品 -->
    <div class="container module-space">
      <v-newGrpupedProduct
          v-if="group_product && group_product.length && groupProduct.position === 'foot'"
          :group_product="group_product"
          :group_products_title="group_products_title"
          :show_outer="true"
          :pc_style="pc_style"
          :cart_type="cart_type"
          :theme="theme"
      ></v-newGrpupedProduct>
    </div>
    <slot name="modules-list"></slot>
  </div>
</template>

<script>
import getSymbolFromCurrency from "currency-symbol-map";
import { mapActions, mapState } from "vuex";
import mixGroupProduct from "@/js/mixins/mixGroupProduct";
import mixProduct from "@/js/mixins/mixProduct";
import mixProductTag from "@/js/mixins/mixProductTag";
import vProductAdd from "../../../../venue/js/view/product/productAdd";
import vCollapseCard from "@/js/components/common/collapseCard";
import vComments from "@/js/components/view/comments/comments";
import vNewQuickAddCart from "@/js/components/view/quickaddcart/newQuickAddCart.vue"
import vProductSwiper from "./productSwiper";
import vMediaLeft from "../../../../vogue/js/view/product/MediaLeft";
import vMediaFlat from "../../../../vogue/js/view/product/MediaFlat";
import vAmplification from "@/js/components/common/amplification.vue";
import vDescripTabs from "./descriptabs.vue";
import vProductTitle from "./productTitle.vue";
import vNewGrpupedProduct from "@/js/components/view/groupedproduct/newIndex.vue";
import vGuessLike from '@/js/components/view/guesslike/guesslike';
import vProductTag from '@/js/components/view/productTag/productTag';

export default {
  props: [
    //"group_product",
    "variants_show_config",
    "group_product_all",
    "quick_add_cart",
    "product",
    "gallery_show_config",
    "count_down",
    "recommended_product",
    "comment",
    "add_group_products",
    "group_products_title",
    "group_products_position",
    "variant_attrs",
    "cart_type",
    "show_currency_selector",
    "paypal_product_position",
    "enable_facebook",
    "enable_twitter",
    "enabel_pinterest",
    "code_display",
    "currency_style",
    "mb_gallery",
    "paypal_enabled",
    "sharing_incentives",
    "product_tabs",
    "gallery_postion",
    "payment_img",
    "is_custom_button",
    "palette_config",
    "visitors_counter",
    "pic_zoom",
    "show_comment_score",
    "show_product_price",
    "hide_number_select",
    "show_style",
    "narrowerscreen",
    "card_type",
    "theme",
    "style_combination_enable",
    "style_combination",
    "combination_config",
    "product_tag",
    "enable_size_chart",
    "quickAddCart",
  ],
  data() {
    return {
      product_res: {},
      count_down_show: false,
      variant: [], //绑定数据
      smallimg: [],
      show_recommended: "",
      pc_style: false,
      add_cart_data: {
        product_id: null,
        quantity: 1,
        // variant_id: null,
      },
      now_variant: {},
      getSymbolFromCurrency,
      stock: true,
      screenWidth: "",
      bulk_coupon: {},
      has_bulk_coupon: false,
      buyxgety_coupon: [],
      incentives_data: [],
      code_display_show: [],
      tabs_page: {},
      custom_button: null,
      palette_attrs: [],
      visitors: null,
      hide_add_btn: false,
      swiper_index: {
        activeIndex: 0,
      },
      describe_tabs: [],
      now_variant_list: [], //遇到需要特殊处理的属性需要保存多个已选变种
      add_cart_list: [], //遇到需要特殊处理的属性需要保存多个已选变种加购信息
      combinations: {}, //用于存放款式组合数据
      combination_active: 0, //款式组合当前商品索引
      mixin_in_product: true, //在min中判断是否为商品详情页的
      price:0,
      regularPrice:0,
      buyxgetySetting: {}, //满送优惠设置
    };
  },
  mixins: [mixProduct, mixProductTag,mixGroupProduct],
  methods: {
    ...mapActions({
      get_product_tag: "change_product_tag_list", //获取产品tag
    }),
    product_from_id() {
      this.variant_id = this.getSearch("variant=");
      if (
        this.variant_id &&
        this.product.variants &&
        this.product.variants.length
      ) {
        this.product.variants.some((item) => {
          if (item.ID == this.variant_id) {
            this.variant.forEach((variant_item) => {
              item.attrs.some((attrs_item) => {
                if (variant_item.name == attrs_item.name) {
                  variant_item.value = attrs_item.value;
                  return true;
                }
              });
            });
          }
        });
      }
    },
    add_cart(data,onlySelf) {
      this.$refs.productadd.add_cart(data,onlySelf);
    },
  },
  created() {
    if (this.palette_config) {
      let params = {
        'filter[product_id]': this.product.ID,
      }
      this.$axios.get(API.palette, { params }).then((res) => {
        if(res&&res.data&&res.data[this.product.ID]&&res.data[this.product.ID].length){
          this.palette_attrs = res.data[this.product.ID];
          this.create_attrs();
        }
      })
    }
    this.$axios.get(API.get_coupons + this.product.ID).then((res) => {
      let { bulk_coupon, buyxgety_coupon, setting } = res.data;
      if (bulk_coupon) {
        this.bulk_coupon = bulk_coupon;
        this.has_bulk_coupon = true;
      }
      if (buyxgety_coupon) {
        this.buyxgety_coupon = buyxgety_coupon;
      }
      if (setting) {
        this.buyxgetySetting = setting
      }
    });
    if (this.code_display) {
      this.$axios.get(API.get_code_display + this.product.ID).then((res) => {
        console.log("get_code_display", res);
        this.code_display_show = res.data;
      });
    }
    if (this.sharing_incentives) {
      this.$axios.get(API.incentives + this.product.ID).then((res) => {
        const { data } = res.data;
        this.incentives_data = data;
      });
    }
    if (this.is_custom_button) {
      this.hide_add_btn = true;
      this.$axios
        .get(API.custom_button, {
          params: { product_ids: this.product.ID },
        })
        .then((res) => {
          this.custom_button = res.data[0].custom_button;
          let { is_cart_detail_page } = this.custom_button;
          this.hide_add_btn = !!is_cart_detail_page;
          console.log("isDataDataData", res.data);
        });
    }
    if (this.visitors_counter) {
      this.$axios.get(API.visitors_counter + this.product.ID).then((res) => {
        console.log("visitors_counter", res);
        this.visitors = res.data;
      });
    }
    if (this.style_combination_enable) {
      this.$axios
        .get(`${API.style_combination}?filter[product_ids]=${this.product.ID}`)
        .then((res) => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            this.combinations = res.data.data[0].style_combination;
            this.combinations.items?.forEach((item, index) => {
              if (item.product_id == this.product.ID) {
                this.combination_active = index;
              }
            });
          }
        });
    }
    if (this.recommended_product) {
      this.show_recommended = !this.recommended_product.shieldProduct.includes(
        this.product.ID
      );
    }
    if (this.product_tag) {
      this.get_product_tag(this.product.ID);
    }
    if (this.count_down) {
      this.count_down_show =
        this.count_down.detail.type == "all" ||
        this.count_down.detail.product_ids.includes(this.product.ID) ||
        this.count_down.detail.category_ids.some((item) => {
          return this.product.categories.some((subitem) => {
            return subitem.id == item;
          });
        });
    }
    this.bus.$on("get_variant", (res) => {
      this.variant[res.index].value = res.val;
    });
  },
  beforeMount() {
    if (this.$(window).width() > 768) {
      this.pc_style = true;
    } else {
      this.pc_style = false;
    }
    this.$store.dispatch("change_now_variant", this.now_variant);
    this.product_from_id();
  },
  async mounted() {
    let arr = [];
    let getAll = [];
    if (
      this.product_tabs &&
      this.product_tabs.length &&
      this.product_tabs.length > 0
    ) {
      let describeFlag = -1
      this.product_tabs.forEach((item, index) => {
        let obj = {};
        if (item.type == "describe") {
          obj = {
            title: item.title,
            content: this.product_res.post_content,
            type: "describe",
            show: item.show,
          };
          if(describeFlag !== -1 ){
            if(obj?.title){
              arr.splice(describeFlag, 1)
              arr.push(obj)
              describeFlag = arr.length - 1
            }
          }else {
            arr.push(obj);
            describeFlag = arr.length - 1
          }
        } else if (item.type == "others") {
          obj = {
            title: item.title,
            content: item.content || "",
            type: item.type,
          };
          arr.push(obj);
        } else if (item.type == "page" && item.page_id) {
          let p = new Promise((resolve, reject) => {
            this.$axios.get(`/api/store/pages/${item.page_id}`).then((res) => {
              if (res.data) {
                res.data.position = index;
              }
              resolve(res.data);
            });
          });
          getAll.push(p);
        }
      });
      if (getAll.length) {
        await Promise.all([...getAll]).then((res) => {
          res.forEach((item) => {
            let obj = {
              title: item.title,
              content: item.content,
              type: "page",
            };
            arr.splice(item.position, 0, obj);
          });
        });
      }
    } else {
      let obj = {
        title: 'Description',
        type:'describe',
        content: this.product_res.post_content,
      };
      arr.push(obj);
    }

    if(this.product?.meta_fields?.space?.key_specification){
      let obj={
        title:this.product.meta_fields.space.key_specification?.name || 'SPECIFICATION',
        type:this.product.meta_fields.space.key_specification?.type,
        content:this.product.meta_fields.space.key_specification?.value
      };
      arr.splice(1,0,obj);
    }
    this.describe_tabs = arr;

    //获取浏览器宽度
    this.screenWidth = document.body.clientWidth;
    //调用window.onresize监听浏览器窗口变化
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
    this.send_fb_event("ViewContent", {
      content_type: "product_group",
      content_ids: [this.product.ID],
      value:
        this.product["variants"] && this.product["variants"].length
          ? this.product["variants"][0]["price"]
          : this.product["price"],
      content_name:
        this.product["variants"] && this.product["variants"].length
          ? this.product["variants"][0]["title"]
          : this.product["title"],
      currency: window.checkoutcurrency,
      content_category:
        this.product["categories"] && this.product["categories"].length
          ? this.product["categories"][0]["name"]
          : "",
    });
    this.send_ttp_event("ViewContent", {
      content_type: "product_group",
      content_id: [this.product.ID],
      value:
        this.product["variants"] && this.product["variants"].length
          ? this.product["variants"][0]["price"]
          : this.product["price"],
      currency: window.checkoutcurrency,
    });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    mainProduct() {
      return this.groupProduct?.hasOwnProperty('position') && this.groupProduct.position != 'button_above' && this.product
    },
    ...mapState({
      // 组合商品配置
      groupProduct: ({ plugConfig }) => plugConfig.groupProduct || {},
      // 启用tabs
      isTabs: ({ options }) => options?.theme?.pages?.product?.config?.tabs
    }),
  },
  watch: {
    screenWidth(val) {
      if (this.screenWidth > 768) {
        this.pc_style = true;
      } else {
        this.pc_style = false;
      }
    },
  },
  components: {
    vProductAdd,
    vComments,
    vMediaLeft,
    vProductSwiper,
    vMediaFlat,
    vCollapseCard,
    vAmplification,
    vDescripTabs,
    vProductTitle,
    vNewQuickAddCart,
    vNewGrpupedProduct,
    vGuessLike,
    vProductTag,
  },
};
</script>

<style scoped  lang='scss'>
.product-template-section {
  .container {
    display: flex;
    padding-top: 40px;
    .product-left {
      width: 50%;
      .flatGalleryImg {
        padding: 0;
      }
    }
    .product-right {
      width: 50%;
      padding-left: 30px;
      &::v-deep .product_single_content_box {
        .product_single_price_text {
          margin-top: 9px;
        }
        .product_single_add .product_single_add_button {
          line-height: 1;
          .selectpricewrap .money {
            & > span:nth-child(1) {
              margin-right: -6px;
            }
          }
        }
        .product_single_price {
          .money {
            font-family: "Muli-ExtraBold" !important;
            & > span:nth-child(1) {
              margin-right: -6px;
            }
          }
        }
      }
      .productDescriptionWrap {
        margin-top: 20px;
        border-top: 1px solid #e3e3e3;
        &::v-deep {
          .collapseCardTitle {
            margin-bottom: 0;
            padding: 25px 0 !important;
            h5 {
              font-size: 20px !important;
              // font-family: "Muli-Bold";
              color: #454545;
            }
            .arrows-bottom,
            .arrows-top,
            .arrows-left,
            .arrows-right {
              border-right: 2px solid #000;
              border-bottom: 2px solid #000;
              @media screen and (max-width: 768px) {
                width: 8px !important;
                height: 8px !important;
              }
            }
          }
        }
        .product-description {
          overflow-x: auto;
          font-size: 16px;
          line-height: 1.65;
          padding-bottom: 32px;
          p {
            margin-bottom: 0;
          }
          ul {
            li {
              list-style: inside;
            }
          }
          img,
          iframe,
          video {
            max-width: 100% !important;
          }
          pre {
            white-space: pre-wrap;
          }
        }
      }
      &::v-deep .product_single_share {
        margin-top: 12px;
      }
    }
  }
}
.module-space {
  margin-top: 56px;
}
::v-deep {
  .waterfall_box {
    .report {
      display: none !important;
    }
  }
}
::v-deep{
  .commentsItemBox{
    .commentsUl_flat_update_pc{
      div:last-child{
        .more_reviews_btn{
          border: 1px solid #979CAC;
          padding: 24px 56px;
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  .product-template-section {
    .narrowerscreen {
      max-width: 1200px;
      padding-left: 50px;
      .product-left {
        width: 632px;
        width: 56.4285%;
      }
      .product-right {
        width: 41.3392%;
        padding-left: 61px;
        margin-left: -12px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .product-template-section {
    padding-bottom: 27px;
    .title {
      width: 250px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
    }
    .container {
      flex-wrap: wrap;
      // padding-left: 24px !important;
      // padding-right: 24px !important;
      padding-top: 0px;
      .product-left {
        margin-top: 15px;
        width: 100% !important;
        // margin-left: -24px;
        // margin-right: -24px;
        flex-grow: 1;
        // .product-col-left {
        //   max-width: 100%;
        // }
      }
      .product-right {
        width: 100% !important;
        padding-left: 0 !important;
        &::v-deep .product_single_content_box {
          .product_single_price_text {
            margin-top: -5px;
          }
        }
        &::v-deep .collapseCard {
          .collapseCardTitle {
            padding-top: 20px !important;
            padding-bottom: 20px !important;
            h5 {
              font-size: 15px !important;
            }
          }
        }
        div {
          .select-sort-by {
            width: 100%;
          }
        }
      }
    }
    :not(header).container {
      &::v-deep .PageOverlay{
        z-index:999
      }
    }
  }
  .module-space {
    margin-top: 0;
  }
}
</style>
